import { faArrowLeft, faMinusCircle, faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Autocomplete, Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, styled, Table, TableBody, TableCell, TableHead, TableRow, TextField } from '@mui/material'
import { MobileDatePicker } from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Page from '../../component/Page'
import { getItemMasterList } from '../setting/services/settingApi'
import { STOCK_CONFIG } from '../stock/config'
import SaleContext from './services/saleApi'
import api from '../../api/api'
import Swal from 'sweetalert2'
import { useSelector } from 'react-redux'
import { SALE_CONFIG } from './config'
import { StockStatus } from '../stock/services/stockService'
import ConfirmDialogPromotion from './component/confirmDialogPromotion'
import ConfirmDialogPrintpromotion from './component/confirmDialogPrintpromotion'
import './viewPromotion.scss'
const BrowserInput = function BrowserInput(props) {
    const { inputProps, InputProps, ownerState, value, inputRef, error, ...other } = props;
    return (
        <TextField {...inputProps} ref={inputRef} value={value ? value.substring(0, value?.length - 6) + (parseInt(value?.substring(value?.length - 6)) + 543).toString() : null} {...other} variant="standard" fullWidth
            InputProps={{
                disableUnderline: true,
            }}
        />
    );
};
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    background: '#fff !important', border: 'none'
}));

export default function ViewPromotion() {
    const navigate = useNavigate();
    const { id } = useParams()
    const { profile, loading } = useSelector(state => state.profile)
    const { getPromotionDetail, getAllLots } = useContext(SaleContext)
    const [detail, setDetail] = useState()
    const [refNo, setRefNo] = useState()
    const [documentDate, setDocumentDate] = useState()
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    const [campaignName, setCampaignName] = useState()
    const [name, setName] = useState('')
    const [year, setYear] = useState('')
    const [items, setItems] = useState([])
    const [lots, setLots] = useState([])
    const [itemNo, setItemNo] = useState()
    const [open, setOpen] = useState(false);
    const [openC, setOpenC] = useState(false);
    const [openP, setOpenP] = useState(false);
    const [promotionPrice, setPromotionPrice] = useState();
    const [refNoError, setrefNoError] = useState(false);
    const [campaignError, setcampaignError] = useState(false);
    const [SDateError, setSDateError] = useState(false);
    const [EDateError, setEDateError] = useState(false);


    const [value, setValue] = useState([])
    const [rows, setRows] = useState([]);
    const [loadingPDF, setLoadingPDF] = React.useState(false);

    const deletehand = (i) => {
        const data = rows?.filter((e) => i !== e?.Lot);
        setRows(data);
    };
    const handleClose = () => {
        setValue([])
        setOpen(false)
    };
    const handleSubmit = () => {
        const item = value?.map((v) => {
            v.PromotionPrice = promotionPrice || 0;
            return v;

        });
        // const newItem = rows.filter((x) => item.map((y) => y.Lot === x.Lot))
        // console.log(newItem)

        // newItem.push(...item)
        rows.push(...item)
        // setRows(newItem)
        setOpen(false)
        setValue([])
    };

    useEffect(() => {
        if (id) {
            getPromotionDetail(id, setDetail)
        }
    }, [])
    useEffect(() => {
        if (id) {
            setRefNo(detail?.RefNo)
            setDocumentDate(dayjs(detail?.DocumentDate))
            setStartDate(dayjs(detail?.StartDate))
            setEndDate(dayjs(detail?.EndDate))
            setCampaignName(detail?.CampaignName)
            setRows(detail?.PromotionDetails)
        }

    }, [detail])

    useEffect(() => {
        getItemMasterList(name, setItems)
    }, [name])

    const getLots = async () => {

        // let _params = '';
        // let _ItemNo = '';

        // if (ItemNo) {
        //     _ItemNo = '?ItemNo=' + ItemNo;
        // }
        // _params = _ItemNo

        const url = STOCK_CONFIG.requests.getAllLot.url + `/${itemNo.ItemNo}/all-lots`;
        const res = await api.get(url + '?limit=1000' + `&year=${year}`)
        const data = res.data
        if (data.status === true) {
            if (data.result.items.length > 0) {
                setLots(data.result.items)
                setOpen(true)
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'ไม่พบข้อมูล',
                })
            }
        }
    }

    const handleAdd = (e) => {
        const body = {
            BranchNo: detail?.BranchNo || profile?.BranchNo?.BranchNo,
            PromotionNo: id || null,
            RefNo: refNo,
            DocumentDate: dayjs(documentDate).format('YYYY-MM-DD'),
            CampaignName: campaignName,
            StartDate: dayjs(startDate).format('YYYY-MM-DD'),
            EndDate: dayjs(endDate).format('YYYY-MM-DD'),
            Status: e,
            PromotionDetails: rows?.map((x) => (
                {
                    ItemNo: x?.ItemNo?.ItemNo,
                    Lot: x?.Lot,
                    NormalPrice: x?.NormalPrice,
                    PromotionPrice: x?.PromotionPrice
                }
            ))
        }
        const promotionAdd = async () => {

            if (body?.PromotionNo) {
                const url = SALE_CONFIG.requests.promotion.url + `/${body?.PromotionNo}`;
                const res = await api.put(url, body)
                const data = res.data
                if (data.status === true) {
                    navigate('/sale/promotion/' + data.result.PromotionNo)
                    setOpenC(false)
                    setOpenP(true)
                }
            } else {

                const res = await api.post(SALE_CONFIG.requests.promotion.url, body)
                const data = res.data
                if (data.status === true) {
                    navigate('/sale/promotion/' + data.result.PromotionNo)
                    setOpenC(false)
                    setOpenP(true)
                }
                else {
                    Swal.fire({
                        title: data?.message || 'ทำรายการไม่สำเร็จ',
                        icon: 'warning',
                    })
                }
            }

        }
        promotionAdd()
    }

    async function downloadPromotionPrice() {
        setLoadingPDF(true)
        const res = await api.get(SALE_CONFIG.requests.promotion.url + `/${id}/pdf`, {
            responseType: 'arraybuffer'
        })
        const buffer = res.data
        const blob = new Blob([buffer], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        setLoadingPDF(false)
    }

    const onBlurS = (e) => {
        if (!e.target.value) {
            setSDateError(true)
        } else {
            setSDateError(false)
        }
    }
    const onBlurE = (e) => {
        if (!e.target.value) {
            setEDateError(true)
        } else {
            setEDateError(false)
        }
    }
    return (
        <>
            <div style={{ padding: '10px 30px' }}>
                <Page>
                    <form >
                        <div class="container-fluid">
                            <div class="d-flex row align-items-center ">
                                <div class="col-6">
                                    <label class="title-content mb-4">
                                        ข้อมูลราคาเฉพาะกิจ
                                    </label>
                                </div>
                                {id &&
                                    <div class="col-6 text-end px-4">
                                        <Button variant='contained' className="ButtomSearch" sx={{
                                            width: '110px',
                                            background: '#3364af57 0 0 no-repeat padding-box',
                                            border: '1px solid #3364af57',
                                            color: '#3364af',
                                            fontWeight: '700',
                                            borderRadius: '100px', ':hover': {
                                                background: '#3364af57 0 0 no-repeat padding-box',
                                            }
                                        }} onClick={downloadPromotionPrice}>{loadingPDF ? <CircularProgress size={'18px'} color="inherit" /> : 'พิมพ์'}</Button>
                                    </div>}

                            </div>
                            <div class="row">
                                <div class="col-lg-4 col-md-12">
                                    <label class="labelInput">เลขที่เอกสาร</label>
                                    <Box className={`backgroundField ${refNoError ? 'error' : ''}`} >
                                        <TextField value={refNo} onChange={e => setRefNo(e.target.value)} variant="standard" fullWidth onBlur={e => {
                                            if (!e.target.value) {
                                                setrefNoError(true)
                                            } else {
                                                setrefNoError(false)
                                            }
                                        }}
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />
                                    </Box>
                                </div>
                                <div class="col-lg-4 col-md-6">
                                    <label class="labelInput">วันที่เอกสาร</label>
                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                        <MobileDatePicker
                                            dayOfWeekFormatter={(day) => `${day}`}
                                            value={documentDate} onChange={e => setDocumentDate(e)}
                                            slotProps={{ textField: { variant: 'standard', fullWidth: true, InputProps: { disableUnderline: true }, value: documentDate } }}
                                            slots={{
                                                textField: BrowserInput,
                                            }}
                                        />
                                    </Box>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-lg-8 col-md-6" style={{ marginBottom: '10px' }}>
                                    <label class="labelInput">โครงการ</label>
                                    <Box className={`backgroundField ${campaignError ? 'error' : ''}`} >
                                        <TextField value={campaignName} onChange={e => setCampaignName(e.target.value)} variant="standard" fullWidth
                                            onBlur={e => {
                                                if (!e.target.value) {
                                                    setcampaignError(true)
                                                } else {
                                                    setcampaignError(false)
                                                }
                                            }}
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />
                                    </Box>
                                    {campaignError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณากรอกชื่อโครงการ</span>}

                                </div>


                            </div>
                            <div class="row">
                                <div class="col-lg-4 col-md-6">
                                    <label class="labelInput">วันที่เริ่มต้น</label>
                                    <Box className={`backgroundField ${SDateError ? 'error' : ''}`} sx={{ marginBottom: '10px' }}>
                                        <MobileDatePicker
                                            dayOfWeekFormatter={(day) => `${day}`}
                                            value={startDate} onChange={e => setStartDate(e)}
                                            slotProps={{ textField: { variant: 'standard', fullWidth: true, InputProps: { disableUnderline: true }, value: startDate, onBlur: onBlurS } }}
                                            slots={{
                                                textField: BrowserInput,
                                            }}
                                        />
                                    </Box>
                                    {SDateError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณากรอกวันที่เริ่มต้น</span>}

                                </div>
                                <div class="col-lg-4 col-md-6">
                                    <label class="labelInput">วันที่สิ้นสุด</label>
                                    <Box className={`backgroundField ${EDateError ? 'error' : ''}`} sx={{ marginBottom: '10px' }}>
                                        <MobileDatePicker
                                            minDate={startDate}
                                            dayOfWeekFormatter={(day) => `${day}`}
                                            value={endDate} onChange={e => setEndDate(e)}
                                            slotProps={{ textField: { variant: 'standard', fullWidth: true, InputProps: { disableUnderline: true }, value: endDate, onBlur: onBlurE } }}
                                            slots={{
                                                textField: BrowserInput,
                                            }}
                                        />
                                    </Box>
                                    {EDateError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณากรอกวันที่สิ้นสุด</span>}

                                </div>

                            </div>
                            {id &&
                                <div class="row">
                                    <div class="col-lg-4 col-md-6">
                                        <label class="labelInput me-3">ผู้สร้าง</label> <label class="message-error-label">( {dayjs(detail?.CreateDate).format('DD/MM/BBBB')} )</label>
                                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                            <TextField disabled value={detail?.CreateId} variant="standard" fullWidth
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                            />
                                        </Box>
                                    </div>
                                    <div class="col-lg-4 col-md-6">
                                        <label class="labelInput me-3">ผู้แก้ไข</label> <label class="message-error-label">( {dayjs(detail?.ModifiedDate).format('DD/MM/BBBB')} )</label>
                                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                            <TextField disabled value={detail?.ModifiedId} variant="standard" fullWidth
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                            />
                                        </Box>
                                    </div>
                                </div>
                            }


                            <div class="d-flex row align-items-baseline  mt-5 ">
                                <div class="col-6">
                                    <label class="title-content">
                                        รายการเมล็ดพันธุ์
                                    </label>
                                </div>
                                <div class="col-6 d-flex justify-content-end align-item-center">
                                    <Box className='backgroundField' sx={{ marginBottom: "10px", marginRight: "10px" }}>
                                        <TextField placeholder='ปี' value={year} onChange={e => setYear(e.target.value)}  variant="standard" fullWidth style={{width:"50px",}}
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                            inputProps={{ maxLength: 2 }}

                                        />
                                    </Box>
                                    <Box className='backgroundField' sx={{ marginBottom: "10px" }}>

                                        <Autocomplete
                                            fullWidth
                                            size='small'
                                            options={items}
                                            getOptionLabel={(option) => option?.ItemName}
                                            renderOption={(props, option) => (
                                                <Box component="li" {...props} key={option.ItemId}>
                                                    {option?.CatalogNo?.CatalogName} {option?.Option2} <span style={{ color: option?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold', margin: '0 10px' }}>{option?.Season}</span> {option?.Option1} {option?.Chemical}
                                                </Box>
                                            )}
                                            componentsProps={{
                                                paper: {
                                                  sx: {
                                                    width: 500
                                                  }
                                                }
                                              }}
                                            // value={itemNo}
                                            onChange={(event, newValue) => {
                                                setItemNo(newValue)
                                            }}
                                            value={itemNo}

                                            renderInput={(params) =>
                                            // <TextField {...params} variant="standard" fullWidth placeholder="ค้นหา เลขที่เอกสาร"
                                            //     InputProps={{
                                            //         disableUnderline: true,
                                            //         startAdornment: <Box sx={{ marginRight: '10px' }}><FontAwesomeIcon icon={faSearch} /></Box>,
                                            //     }}
                                            // />
                                            (
                                                <TextField {...params} placeholder="ค้นหา เมล็ดพัันธุ์" fullWidth variant="standard" style={{width:"250px"}} />
                                            )}
                                        />
                                    </Box>
                                    <Button onClick={() => getLots()} variant='contained' sx={{ width: '150px', marginLeft:"10px", height:'46px' }}>ค้นหา</Button>

                                </div>
                            </div>
                            <div class="viewPromotion row">
                                <div class="col-md-12 table-responsive-sm " style={{ height: 'auto' }}>
                                    <table class="table table-borderless  ">
                                        <thead>
                                            <tr>
                                                <th scope="col ">ที่</th>
                                                <th scope="col ">เมล็ดพันธุ์</th>
                                                <th scope="col ">ปี</th>
                                                <th scope="col ">ล็อต</th>

                                                <th scope="col ">ราคาปกติ</th>
                                                <th scope="col " style={{ width: '200px' }}>ราคาเฉพาะกิจ </th>
                                                <th ></th>
                                            </tr>
                                        </thead>
                                        <tbody class="">
                                            {rows?.map((x, i) => (
                                                <tr >

                                                    <td class="text-center">{i + 1}.</td>
                                                    <td class="text-center">
                                                        {x?.ItemNo?.CatalogNo?.CatalogName} {x?.ItemNo?.Option2} <span style={{ color: x?.ItemNo?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold', margin: '0 10px' }}>{x?.ItemNo?.Season}</span> {x?.ItemNo?.Option1} {x?.ItemNo?.Chemical}
                                                    </td>
                                                    <td class="text-center">{x?.Year}</td>
                                                    <td class="text-center">{x?.Lot}</td>

                                                    <td class="text-center">{x?.SalePrice || x?.NormalPrice}</td>
                                                    <td class="text-center">
                                                        <TextField type='number' value={x?.PromotionPrice} size='small' fullWidth variant='outlined' onChange={e => {
                                                            const item = rows?.map((v) => {
                                                                v.PromotionPrice = v?.Lot === x?.Lot ? e.target.value : v?.PromotionPrice;
                                                                return v;

                                                            });
                                                            setRows([...item]);
                                                        }} /></td>
                                                    <td><FontAwesomeIcon icon={faMinusCircle} onClick={() => deletehand(x.Lot)} /></td>

                                                </tr>
                                            ))}


                                        </tbody>
                                    </table>
                                </div>


                            </div>
                            <hr class="chr" />
                            <div class="row mt-4">

                                <div class="col-12 ">
                                    <Button onClick={() => navigate(-1)} variant='outlined'
                                        startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                                        sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
                                    {profile?.BranchNo?.BranchNo === '00' && <>
                                        {!detail || detail?.Status !== 'N' ?
                                            <Button variant='contained' sx={{ width: '130px', fontSize: '14px' }} onClick={() => {
                                                if (!refNo) {
                                                    setrefNoError(true)
                                                }

                                                if (!campaignName) {
                                                    setcampaignError(true)
                                                }
                                                if (!startDate) {
                                                    setSDateError(true)
                                                }
                                                if (!endDate) {
                                                    setEDateError(true)
                                                }

                                                if (campaignName && refNo && startDate && endDate) {
                                                    setOpenC(true)
                                                }
                                            }
                                            }>{id ? 'แก้ไข' : 'บันทึก'}</Button> : null
                                        }
                                        {detail && detail?.Status !== StockStatus.Inactive &&
                                            <Button color='error' variant='contained' sx={{ width: '130px', fontSize: '14px', marginLeft: '10px' }} onClick={() => handleAdd(StockStatus.Inactive)} >ยกเลิก</Button>
                                        }
                                    </>}
                                </div>
                            </div>
                        </div>
                    </form>
                </Page>
            </div>
            <Dialog
                fullWidth
                maxWidth='lg'
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" sx={{ color: "#3364af", fontWeight: '600' }}>
                    รายการล็อตเมล็ดพันธุ์ {lots[0]?.ItemNo?.CatalogNo?.CatalogName} {lots[0]?.ItemNo?.Option2} <span style={{ color: lots[0]?.ItemNo?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold', margin: '0 10px' }}>{lots[0]?.ItemNo?.Season}</span> {lots[0]?.ItemNo?.Option1} {lots[0]?.ItemNo?.Chemical} {year}

                </DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '0px 16px 16px 16px' }}>
                        <TextField placeholder="กรอก ราคาเฉพาะกิจ(บาท)" onChange={e => setPromotionPrice(e.target.value)} variant='outlined' sx={{ width: "290px" }} />
                        <Box className='backgroundField'>
                            <TextField variant="standard" fullWidth placeholder="ค้นหา Lots"
                                InputProps={{
                                    disableUnderline: true,
                                    startAdornment: <Box sx={{ marginRight: '10px' }}><FontAwesomeIcon icon={faSearch} /></Box>,
                                }}
                            />
                        </Box>
                    </Box>
                    <Table sx={{ width: '100%' }} aria-label="customized table">

                        <TableRow>
                            <StyledTableCell align="center" sx={{ fontWeight: '600', fontSize: '1rem' }}>ล็อตเมล็ดพันธุ์</StyledTableCell>
                            <StyledTableCell align="center" sx={{ fontWeight: '600', fontSize: '1rem' }}>ศูนยเมล็ดพันธุ์ข้าว</StyledTableCell>
                            <StyledTableCell align="center" sx={{ fontWeight: '600', fontSize: '1rem' }}>จำนวนวันที่อยู่ในคลัง</StyledTableCell>
                            <StyledTableCell align="center" sx={{ fontWeight: '600', fontSize: '1rem' }}>โรงเก็บ</StyledTableCell>
                            <StyledTableCell align="center" sx={{ fontWeight: '600', fontSize: '1rem' }}>จำหน่าย</StyledTableCell>
                        </TableRow>

                        {lots?.map((x) => (
                            <TableRow >
                                <StyledTableCell align="left">
                                    <Box sx={{ border: '1px solid #000', paddingLeft: '10px', borderRadius: '5px' }}>
                                        <FormControlLabel control={<Checkbox onChange={e => {
                                            if (e.target.checked) {
                                                if (value?.filter((y) => y.Lot === x?.Lot).length === 0) {
                                                    value.push(x)
                                                }
                                            }
                                        }} />} label={x?.Lot} />
                                    </Box>
                                </StyledTableCell>
                                <StyledTableCell align="center">{x?.BranchNo?.BranchName}</StyledTableCell>
                                <StyledTableCell align="center">{x?.DaysInStock} วัน</StyledTableCell>
                                <StyledTableCell align="center">{x?.WarehouseNo?.WarehouseName}/ {x?.ZoneNo?.ZoneName}</StyledTableCell>
                                <StyledTableCell align="center">{parseFloat(x?.SalePrice).toFixed(2)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</StyledTableCell>
                            </TableRow>
                        ))}

                    </Table>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant='outlined' sx={{ width: '150px' }}>ยกเลิก</Button>
                    <Button onClick={() => {
                        if (value.length === 0) {
                            Swal.fire(
                                'กรุณาเลือก Lot',
                                '',
                                'error'
                            )
                        } else {
                            handleSubmit()
                        }
                    }} variant='contained' sx={{ width: '150px' }}>
                        ตกลง
                    </Button>
                </DialogActions>
            </Dialog>
            <ConfirmDialogPromotion open={openC} setOpen={setOpenC} rows={rows} handleAdd={handleAdd} />
            <ConfirmDialogPrintpromotion title={'บันทึกรายการราคาเฉพาะกิจสำเร็จ'} download={downloadPromotionPrice} open={openP} setOpen={setOpenP} loadingPDF={loadingPDF} linkTo='/sale/promotion/add' />
        </>
    )
}
